export default {
  // Endpoints
  loginEndpoint: 'v1/auth/login',
  registerEndpoint: 'v1/auth/register',
  refreshEndpoint: 'v1/auth/refresh-token',
  logoutEndpoint: 'v1/auth/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
